"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoolNameArray = void 0;
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
exports.PoolNameArray = [
    "ALPHA",
    "HASUI-SUI",
    "USDY-WUSDC",
    "ALPHA-SUI",
    "USDT-WUSDC",
    "WUSDC-SUI",
    "WUSDC-WBTC",
    "WETH-WUSDC",
    "NAVX-SUI",
    "BUCK-WUSDC",
    "CETUS-SUI",
    "NAVI-SUI",
    "NAVI-VSUI",
    "NAVI-WETH",
    "NAVI-USDT",
    "NAVI-WUSDC",
    "NAVI-HASUI",
    "NAVI-LOOP-SUI-VSUI",
    "ALPHA-WUSDC",
    "WSOL-WUSDC",
    "FUD-SUI",
    "BLUB-SUI",
    "SCA-SUI",
    "NAVI-LOOP-USDC-USDT",
    "NAVI-USDC",
    "USDC-SUI",
    "USDC-USDT",
    "ALPHA-USDC",
    "USDC-WUSDC",
    "BUCKET-BUCK",
    "USDC-ETH",
    "DEEP-SUI",
    "BUCK-SUI",
    "NAVI-USDY",
    "NAVI-AUSD",
    "NAVI-ETH",
    "NAVI-LOOP-HASUI-SUI",
    "NAVI-NS",
];
const ALPHA_SUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHA_SUI_POOL_RECEIPT;
const USDY_WUSDC_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().USDY_WUSDC_POOL_RECEIPT;
const USDT_WUSDC_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().USDT_WUSDC_POOL_RECEIPT;
const ALPHA_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHA_POOL_RECEIPT;
const HASUI_SUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().HASUI_SUI_POOL_RECEIPT;
const WUSDC_SUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().WUSDC_SUI_POOL_RECEIPT;
const WUSDC_WBTC_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().WUSDC_WBTC_POOL_RECEIPT;
const WETH_WUSDC_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().WETH_WUSDC_POOL_RECEIPT;
const NAVX_SUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVX_SUI_POOL_RECEIPT;
const BUCK_WUSDC_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().BUCK_WUSDC_POOL_RECEIPT;
const CETUS_SUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().CETUS_SUI_POOL_RECEIPT;
const NAVI_SUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_SUI_POOL_RECEIPT;
const NAVI_VSUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_VSUI_POOL_RECEIPT;
const NAVI_WETH_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_WETH_POOL_RECEIPT;
const NAVI_USDT_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_USDT_POOL_RECEIPT;
const NAVI_WUSDC_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_WUSDC_POOL_RECEIPT;
const NAVI_HASUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_HASUI_POOL_RECEIPT;
const NAVI_LOOP_SUI_VSUI_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_LOOP_SUI_VSUI_RECEIPT;
const ALPHA_WUSDC_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHA_WUSDC_POOL_RECEIPT;
const WSOL_WUSDC_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().WSOL_WUSDC_POOL_RECEIPT;
const FUD_SUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().FUD_SUI_POOL_RECEIPT;
const BLUB_SUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().BLUB_SUI_POOL_RECEIPT;
const SCA_SUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().SCA_SUI_POOL_RECEIPT;
const NAVI_LOOP_USDC_USDT_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_LOOP_USDC_USDT_RECEIPT;
const NAVI_USDC_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_USDC_POOL_RECEIPT;
const USDC_SUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().USDC_SUI_POOL_RECEIPT;
const USDC_USDT_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().USDC_USDT_POOL_RECEIPT;
const ALPHA_USDC_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHA_USDC_POOL_RECEIPT;
const USDC_WUSDC_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().USDC_WUSDC_POOL_RECEIPT;
const BUCKET_BUCK_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().BUCKET_BUCK_POOL_RECEIPT;
const USDC_ETH_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().USDC_ETH_POOL_RECEIPT;
const DEEP_SUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().DEEP_SUI_POOL_RECEIPT;
const BUCK_SUI_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().BUCK_SUI_POOL_RECEIPT;
const NAVI_USDY_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_USDY_POOL_RECEIPT;
const NAVI_AUSD_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_AUSD_POOL_RECEIPT;
const NAVI_ETH_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_ETH_POOL_RECEIPT;
const NAVI_LOOP_HASUI_SUI_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_LOOP_HASUI_SUI_RECEIPT;
const ALPHAFI_BLUEFIN_SUI_USDC_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_SUI_USDC_RECEIPT;
const ALPHAFI_BLUEFIN_USDT_USDC_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_USDT_USDC_RECEIPT;
const NAVI_LOOP_USDT_USDC_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_LOOP_USDT_USDC_RECEIPT;
const ALPHAFI_BLUEFIN_SUI_BUCK_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_SUI_BUCK_RECEIPT;
const ALPHAFI_BLUEFIN_AUSD_USDC_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_AUSD_USDC_RECEIPT;
const NAVI_NS_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_NS_POOL_RECEIPT;
const ALPHAFI_BLUEFIN_SUI_AUSD_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_SUI_AUSD_RECEIPT;
const ALPHAFI_BLUEFIN_ALPHA_USDC_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_ALPHA_USDC_RECEIPT;
const ALPHAFI_BLUEFIN_WBTC_USDC_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_WBTC_USDC_RECEIPT;
const ALPHAFI_BLUEFIN_NAVX_VSUI_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_NAVX_VSUI_RECEIPT;
const NAVI_NAVX_POOL_RECEIPT = (0, alphafi_sdk_1.getConf)().NAVI_NAVX_POOL_RECEIPT;
const ALPHAFI_BLUEFIN_BLUE_SUI_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_BLUE_SUI_RECEIPT;
const ALPHAFI_BLUEFIN_BLUE_USDC_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_BLUE_USDC_RECEIPT;
const ALPHAFI_BLUEFIN_SEND_USDC_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_SEND_USDC_RECEIPT;
const ALPHAFI_BLUEFIN_WBTC_SUI_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_WBTC_SUI_RECEIPT;
const ALPHAFI_BLUEFIN_DEEP_SUI_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_DEEP_SUI_RECEIPT;
const ALPHAFI_BLUEFIN_STSUI_SUI_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_STSUI_SUI_RECEIPT;
const ALPHAFI_BLUEFIN_STSUI_USDC_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_STSUI_USDC_RECEIPT;
const ALPHAFI_BLUEFIN_STSUI_ETH_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_STSUI_ETH_RECEIPT;
const ALPHAFI_BLUEFIN_STSUI_WSOL_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_STSUI_WSOL_RECEIPT;
const ALPHAFI_BLUEFIN_ALPHA_STSUI_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_ALPHA_STSUI_RECEIPT;
const ALPHAFI_BLUEFIN_AUTOBALANCE_USDT_USDC_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_AUTOBALANCE_USDT_USDC_RECEIPT;
const ALPHAFI_BLUEFIN_AUTOBALANCE_SUI_USDC_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_AUTOBALANCE_SUI_USDC_RECEIPT;
const ALPHAFI_BLUEFIN_SUIUSDT_USDC_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_SUIUSDT_USDC_RECEIPT;
const ALPHAFI_BLUEFIN_AUTOBALANCE_SUIUSDT_USDC_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_AUTOBALANCE_SUIUSDT_USDC_RECEIPT;
const ALPHAFI_BLUEFIN_AUTOBALANCE_DEEP_BLUE_RECEIPT = (0, alphafi_sdk_1.getConf)().ALPHAFI_BLUEFIN_AUTOBALANCE_DEEP_BLUE_RECEIPT;
//# sourceMappingURL=types.js.map